import {inject, Pipe, PipeTransform} from "@angular/core";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

interface HtmlPipeOptions {
    sanitize?: boolean;
}

@Pipe({name: "html"})
export class HtmlPipe implements PipeTransform {
    private domSanitizer: DomSanitizer = inject(DomSanitizer);
    private readonly allowedTags: Set<string> = new Set(["b", "i", "br", "p"]);

    transform(value: string, options?: HtmlPipeOptions): SafeHtml | string {
        return value ? this.domSanitizer.bypassSecurityTrustHtml(this.sanitizeHtml(value.replace(/\n/g, "<br>"), options)) : "";
    }

    private sanitizeHtml(html: string, options?: HtmlPipeOptions): string {
        if (options?.sanitize === false) {
            return html;
        }
        const doc: Document = new DOMParser().parseFromString(html, "text/html");
        this.sanitizeNode(doc.body);
        return doc.body.innerHTML;
    }

    private sanitizeNode(node: Node): void {
        for (const child of Array.from(node.childNodes)) {
            if (child.nodeType === Node.ELEMENT_NODE) {
                const element: Element = child as Element;
                if (this.allowedTags.has(element.tagName.toLowerCase())) {
                    element.removeAttribute("class");
                    element.removeAttribute("style");
                    element.removeAttribute("id");
                    for (const attr of Array.from(element.attributes)) {
                        element.removeAttribute(attr.name);
                    }
                    this.sanitizeNode(element);
                } else {
                    while (element.firstChild) {
                        node.insertBefore(element.firstChild, element);
                    }
                    node.removeChild(element);
                }
            } else if (child.nodeType !== Node.TEXT_NODE) {
                node.removeChild(child);
            }
        }
    }
}
